module.exports = __webpack_public_path__ + "static/media/JAPAN-OsakaU.c9195abb.jpg";